export * from 'cf-core/src/images'
export const Hero404 = 'https://d24rddnpxh8ji7.cloudfront.net/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://d24rddnpxh8ji7.cloudfront.net/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/zomato_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/instagram_white.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const cflogo = 'https://d24rddnpxh8ji7.cloudfront.net/cflogo.png'
export const about =
  'https://d24rddnpxh8ji7.cloudfront.net/sushimotoburnaby/promo2.webp'
export const contactbg =
  'https://d24rddnpxh8ji7.cloudfront.net/myomirichmond/footer.webp'
export const foodGallery =
  'https://d13wypomhtsuhx.cloudfront.net/Mask group.webp'
export const hero =
  'https://d24rddnpxh8ji7.cloudfront.net/myomirichmond/hero.webp'
export const heroText = 'https://d13wypomhtsuhx.cloudfront.net/heroText.webp'
export const locationMap =
  'https://d24rddnpxh8ji7.cloudfront.net/sushimotoburnaby/map2.webp'
export const logo =
  'https://d24rddnpxh8ji7.cloudfront.net/sushimotoburnaby/logo.webp'
export const mobileAbout =
  'https://d24rddnpxh8ji7.cloudfront.net/sushimotoburnaby/mobilePromo.webp'
export const mobileContactbg =
  'https://d24rddnpxh8ji7.cloudfront.net/myomirichmond/mobileContactBg.webp'
export const mobileGallery =
  'https://d13wypomhtsuhx.cloudfront.net/mobileGallery2.webp'
export const mobileHero =
  'https://d24rddnpxh8ji7.cloudfront.net/myomirichmond/mobileHero.webp'
export const mobileLogo =
  'https://d24rddnpxh8ji7.cloudfront.net/tomosushi/mobileLogo2.webp'
export const mobileMap =
  'https://d24rddnpxh8ji7.cloudfront.net/sushimotoburnaby/mobileMap.webp'
export const mobileHeroText =
  'https://d13wypomhtsuhx.cloudfront.net/mobileText.png'
export const mobilePromotion =
  'https://d24rddnpxh8ji7.cloudfront.net/sushimotoburnaby/mobilePromo.webp'
export const orderPickupButton =
  'https://d24rddnpxh8ji7.cloudfront.net/tomosushi/orderButton.webp'
export const promotions =
  'https://d24rddnpxh8ji7.cloudfront.net/sushimotoburnaby/promo2.webp'
export const mobileMenu = 'https://d13wypomhtsuhx.cloudfront.net/viewMenu.webp'
export const uberButton = 'https://d13wypomhtsuhx.cloudfront.net/uberButton.png'
